import { render, staticRenderFns } from "./ticketForm.vue?vue&type=template&id=0c6a85d0&scoped=true"
import script from "./ticketForm.vue?vue&type=script&lang=js"
export * from "./ticketForm.vue?vue&type=script&lang=js"
import style0 from "./ticketForm.vue?vue&type=style&index=0&id=0c6a85d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a85d0",
  null
  
)

export default component.exports